import React, { useContext, useEffect } from "react";
import { CreativeContext } from "./creatives/CreativeCreation";
// import previewMobile from "../assets/images/preview-frame.png";
import Previewframe from "../../src/shared/PreviewFrame";
import FullImagePreview from "../creativePreviews/FullImagePreview";
import WebviewPreview from "../creativePreviews/WebviewPreview";
import FullVideoPreview from "../creativePreviews/FullVideoPreview";
import GalleryPreview from "../creativePreviews/GalleryPreview";
import HalfVideoPreview from "../creativePreviews/HalfVideoPreview";
import VideowithBgPreview from "../creativePreviews/VideowithBgPreview";
import PromotedImagePreview from "../creativePreviews/PromotedImagePreview";
import PromotedVideoPreview from "../creativePreviews/PromotedVideoPreview";
import AnimationPreview from "../creativePreviews/AnimationPreview";
import PromotedGalleryPreview from "../creativePreviews/PromotedGalleryPreview";
import CommentAdPreview from "../creativePreviews/CommentAdPreview";
import BrandAdImagePreview from "../creativePreviews/BrandAdImagePreview";
import NewsImageDesc from "../creativePreviews/NewsImageDesc";
import NewsImageFlip from "../creativePreviews/NewsImageFlip";
import NewsImageLogo from "../creativePreviews/NewsImageLogo";
import VideoExpandable from "../creativePreviews/VideoExpandable";
import VideoSkippable from "../creativePreviews/VideoSkippable";
import VideoEndcard from "../creativePreviews/VideoEndcard";
import BottomRectangle from "../creativePreviews/BottomRectangle";
import SquareClassified from "../creativePreviews/SquareClassified";
import RectangleClassifieds from "../creativePreviews/RectangleClassifieds";
import FramePostPreview from "../creativePreviews/FramePostPreview";
import RecImagePreview from "../creativePreviews/RecImagePreview";
import RecPromotedPreview from "../creativePreviews/RecPromotedPreview";
function PreviewFrame({showPreview}) {
  const { preview } = useContext(CreativeContext);
  return (
    <div>
      <section className="preview-mobile">
        {(preview.sub_type === undefined ||
          preview.sub_type === "" ||
          preview.sub_type === null) && <Previewframe />}
        {preview.sub_type === "full_image" && (
          <FullImagePreview preview={preview} />
        )}
        {preview.sub_type === "webviewad" && (
          <WebviewPreview preview={preview} />
        )}
        {preview.sub_type === "gallery" && <GalleryPreview preview={preview} />}
        {preview.sub_type === "full_video" && (
          <FullVideoPreview preview={preview} />
        )}
        {preview.sub_type === "half_video" && (
          <HalfVideoPreview preview={preview} />
        )}
        {preview.sub_type === "video_with_bg" && (
          <VideowithBgPreview preview={preview} />
        )}
        {preview.sub_type === "promoted_image_story" && (
          <PromotedImagePreview preview={preview} />
        )}
        {preview.sub_type === "promoted_video_story" && (
          <PromotedVideoPreview preview={preview} />
        )}
        {preview.sub_type === "fullvideo_or_gif" && (
          <AnimationPreview preview={preview} />
        )}
        {preview.sub_type === "promoted_gallery" && (
          <PromotedGalleryPreview preview={preview} />
        )}
        {preview.sub_type === "commentad" && (
          <CommentAdPreview preview={preview} />
        )}
        {(preview.sub_type === "search" || preview.sub_type === "unread") && (
          <BrandAdImagePreview preview={preview} />
        )}
        {preview.sub_type === "news_image_flip" && (
          <NewsImageFlip preview={preview} />
        )}
        {preview.sub_type === "news_image_logo" && (
          <NewsImageLogo preview={preview} />
        )}
        {preview.sub_type === "news_short_desc" && (
          <NewsImageDesc preview={preview} />
        )}
        {preview.sub_type === "video_expandable" && (
          <VideoExpandable preview={preview} />
        )}
        {preview.sub_type === "video_endcard" && (
          <VideoEndcard preview={preview} />
        )}
        {preview.sub_type === "video_skippable" && (
          <VideoSkippable preview={preview} />
        )}
         {preview.sub_type === "bottom_rectangle" && (
          <BottomRectangle preview={preview} />
        )}
        {preview.sub_type === "square_classified" && (
          <SquareClassified preview={preview} />
        )}
        {preview.sub_type === "rectangle_classified" && (
          <RectangleClassifieds preview={preview} />
        )}
        {preview.sub_type === "framepost" && (
          <FramePostPreview preview={preview} />
        )}
        {preview.sub_type === "rec_image" && (
          <RecImagePreview preview={preview} />
        )}
        {
          preview.sub_type === "rec_promoted_story" && (
            <RecPromotedPreview preview={preview} />
          )
        }
      </section>
    </div>
  );
}

export default PreviewFrame;
